import PropTypes from 'prop-types';
import React from 'react';

import { injectIntl } from 'react-intl';
import { compose } from 'recompose';
import { Icon } from '@ontruck/orc';

import cx from 'classnames';
import style from './style.module.scss';

import TemperatureIcons from './TemperatureIcons';

const enhance = compose(injectIntl);

const ExtrasSummary = React.memo(
  ({
    sideload_needed,
    liftgate_needed,
    topload_needed,
    extras,
    temperature,
    temperature_ranges,
    showTooltip,
    className,
    intl,
    showTemperature,
    small,
    showHandling,
    color = 'grey500',
    additional_documents,
    config,
    stops,
  }) => {
    const t = intl.messages.components.ExtrasSummary;
    const need_to_be_printed = (additional_documents || []).some((file) => file.need_to_be_printed);

    return (
      <span
        className={cx(style.container, className, {
          [style.smallSize]: small,
        })}
      >
        {liftgate_needed || extras.indexOf('LIFTGATE') >= 0 ? (
          <span title={t.liftgate}>
            <Icon glyph="extras-liftgate" size="2.6rem" color={color} />
          </span>
        ) : null}
        {sideload_needed || extras.indexOf('SIDE_LOAD') >= 0 ? (
          <span title={t.sideload}>
            <Icon glyph="extras-sideload" size="2.6rem" color={color} />
          </span>
        ) : null}
        {topload_needed || extras.indexOf('TOP_LOAD') >= 0 ? (
          <span>
            <Icon glyph="extras-retractableroof" size="2.6rem" color={color} />
          </span>
        ) : null}
        {showHandling &&
        stops &&
        (stops.some((stop) => stop?.extras?.indexOf('HANDLING_LOADING') >= 0) ||
          stops.some((stop) => stop?.extras?.indexOf('HANDLING_UNLOADING') >= 0)) ? (
          <span title={t.handling}>
            <Icon glyph="manipulation" size="1.4rem" color={color} />
          </span>
        ) : null}

        <ExtraAdditionalDocuments
          config={(config && config.additionalDocuments) || {}}
          additional_documents={additional_documents}
          need_to_be_printed={need_to_be_printed}
          color={color}
          t={t}
        />

        {showTemperature ? (
          <TemperatureIcons
            temperature={temperature}
            temperature_ranges={temperature_ranges}
            t={t}
            intl={intl}
            showTooltip={showTooltip}
          />
        ) : null}
      </span>
    );
  }
);

const ExtraAdditionalDocuments = ({
  config: { color = 'grey500', show = true },
  color: defaultColor,
  additional_documents,
  need_to_be_printed,
  t,
}) =>
  show &&
  additional_documents &&
  additional_documents.length > 0 &&
  (need_to_be_printed ? (
    <span title={t.printer_print}>
      <Icon glyph="printer" size="1.4rem" color={color} />
    </span>
  ) : (
    <span title={t.printer_show}>
      <Icon glyph="document" size="2.6rem" color={defaultColor} />
    </span>
  ));

ExtrasSummary.propTypes = {
  sideload_needed: PropTypes.bool,
  liftgate_needed: PropTypes.bool,
  topload_needed: PropTypes.bool,
  extras: PropTypes.array,
  temperature: PropTypes.any,
  temperature_ranges: PropTypes.array,
  showTooltip: PropTypes.bool,
  className: PropTypes.any,
  intl: PropTypes.object,
  showTemperature: PropTypes.bool,
  small: PropTypes.bool,
  showHandling: PropTypes.bool,
  stops: PropTypes.array,

  additional_documents: PropTypes.array,
};

ExtrasSummary.defaultProps = {
  small: false,
  sideload_needed: false,
  liftgate_needed: false,
  showTooltip: true,
  showHandling: true,
  showTemperature: true,
  extras: [],
  temperature_ranges: [],
  stops: [],

  additional_documents: [],
};

export default enhance(ExtrasSummary);
